import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

export const spainConfig: DashboardConfig = {
  path: '/carrefour/spain',
  reportId: 'carrefour-spain-world-cup',
  label: 'Carrefour España',
  apiBaseUrl: clusterBase('eu'),
  endsOn: '2026-07-20', // World Cup, 25 May → 20 Jul — archived from the day after
  frozen: true, // pipeline retired — the frozen payload must never be regenerated
  hide: {
    revenue: true,
    avgBasket: true,
    usersTraffic: true,
    itemsPerTx: true,
  },
};
